import { render } from "./CreatorSimpleCourseView.vue?vue&type=template&id=0e859b90&scoped=true"
import script from "./CreatorSimpleCourseView.vue?vue&type=script&lang=js"
export * from "./CreatorSimpleCourseView.vue?vue&type=script&lang=js"

import "./CreatorSimpleCourseView.vue?vue&type=style&index=0&id=0e859b90&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e859b90"]])

export default __exports__